var _this = this;
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
export default {
  Local: {
    get: function get() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      if (!key) {
        return {};
      }
      return JSON.parse(localStorage.getItem(key) || '{}');
    },
    set: function set() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (!key) {
        return;
      }
      if (!content) {
        _this.remove(key);
        return;
      }
      localStorage.setItem(key, JSON.stringify(content));
    },
    remove: function remove() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      if (!key) {
        return;
      }
      localStorage.removeItem(key);
    },
    clear: function clear() {
      localStorage.clear();
    }
  },
  Session: {
    get: function get() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      if (!key) {
        return {};
      }
      return JSON.parse(sessionStorage.getItem(key) || '{}');
    },
    set: function set() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (!key) {
        return;
      }
      if (!content) {
        _this.remove(key);
        return;
      }
      sessionStorage.setItem(key, JSON.stringify(content));
    },
    remove: function remove() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      if (!key) {
        return;
      }
      sessionStorage.removeItem(key);
    },
    clear: function clear() {
      sessionStorage.clear();
    }
  }
};